import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as AccountedIcon,
  PersonOff as NotAccountedIcon,
  HourglassEmpty as NotCheckedIcon,
} from '@mui/icons-material';
import { appColors } from '../../Config/Theme';
import { PersonStatus } from '../../Types/Incident';
import { getPersonStatusLabel, HEADCOUNT_STATUS_VISUALS } from '../../Utils/headcountStatus';

interface FinalStatusChipProps {
  status: PersonStatus;
}

const chipConfig: Record<PersonStatus, { icon: React.ReactElement; bg: string; border: string; color: string }> = {
  accounted: { icon: <AccountedIcon sx={{ fontSize: 16 }} />, bg: HEADCOUNT_STATUS_VISUALS.accounted.bg, border: HEADCOUNT_STATUS_VISUALS.accounted.color, color: HEADCOUNT_STATUS_VISUALS.accounted.color },
  notAccounted: { icon: <NotAccountedIcon sx={{ fontSize: 16 }} />, bg: HEADCOUNT_STATUS_VISUALS.notAccounted.bg, border: appColors.status.error, color: HEADCOUNT_STATUS_VISUALS.notAccounted.color },
  notChecked: { icon: <NotCheckedIcon sx={{ fontSize: 16 }} />, bg: HEADCOUNT_STATUS_VISUALS.notChecked.bg, border: appColors.text.placeholder, color: HEADCOUNT_STATUS_VISUALS.notChecked.color },
};

const FinalStatusChip: React.FC<FinalStatusChipProps> = ({ status }) => {
  const cfg = chipConfig[status] || chipConfig.notChecked;
  return (
    <Chip
      icon={cfg.icon}
      label={getPersonStatusLabel(status)}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        bgcolor: cfg.bg,
        color: cfg.color,
        border: `1.5px solid ${cfg.border}`,
        '& .MuiChip-icon': { color: cfg.color },
      }}
    />
  );
};

export default FinalStatusChip;
